<!--
菜单项

使用说明：

<MenuItem
 :type="'类型，可选link,custom'"
 :text="'文本'"
 :link="'链接'"
 />

=====

当type=link时候：

<MenuItem
 type="link"
 name="订单管理"
 link="/orders/list"
 />

=====

当type=custom时候：

<MenuItem
 type="custom"
 >
 积分余额：1000分
 <button>去使用</button>
</MenuItem>
-->

<template>
	<div class="wrap" @click="goto()">
		<slot>
			<div class="list-title">
				<i class="icon-wrap" :style="{ backgroundImage: 'url(' + img + ')' }"></i>
				<span>{{ text }}</span>
			</div>
			<i class="icon icon-menu-arrow"></i>
		</slot>
	</div>
</template>

<script>
export default {
	props: ['type', 'text', 'link', 'img'],
	methods: {
		goto() {
			if (this.link.startsWith('http')) {
				window.location.href = this.link;
			} else {
				this.$routerPush(this, this.link);
			}
		},
	},
};
</script>

<style lang="less" scoped>
.list-title {
	display: flex;
	align-items: center;
	vertical-align: middle;
	.icon-wrap {
		display: block;
		margin-right: 2.9vw;
		width: 5.33vw;
		height: 5.4vw;
		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;

		&.cover {
			background-size: cover;
		}
	}
}

.wrap {
	width: 100%;
	height: 13.3vw;
	margin: 4.8vw auto;
	font-size: 3.73vw;
	color: #3b3b3b;
	background: #fff;
	// border-radius: 1.3vw;
	padding: 0 4.26vw;
	box-sizing: border-box;
	display: flex;
	justify-content: space-between;
	-webkit-box-sizing: border-box;
	.icon {
		height: 1.6vw;
		width: 2.67vw;
		background-image: url('../../assets/r_icon.png');
		background-size: contain;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/setting/MenuItem.vue